import { DoodProductModel } from '@core/models/product.model';
import { IAdditionGroup } from '@core/models/shop.model';
import { Stepper } from '../stepper.type';

export class StepperUtil {
  static findStepperWithNextStep(stepper: Stepper | undefined) {
    if (!stepper) {
      return;
    }
    let lastStepperWithNextStep = stepper;
    let recursiveStepper = stepper;

    while (recursiveStepper.childStepper) {
      recursiveStepper = recursiveStepper.childStepper;
      if (recursiveStepper.step.hasNextStep) {
        lastStepperWithNextStep = recursiveStepper;
      }
    }
    return lastStepperWithNextStep;
  }
}

export function getAdditionGroupPosition({
  product,
  allProducts,
  groupId,
  additionsGroups,
}: {
  product: DoodProductModel | undefined;
  allProducts: DoodProductModel[];
  groupId: string;
  additionsGroups: IAdditionGroup[];
}) {
  const additionProductsFromGroup = product?.additions.products
    .map(addition => {
      const additionProduct = allProducts.find(product => product.id === addition);
      return additionProduct;
    })
    .filter(product => product?.addition_group === groupId);
  const additionGroup = additionsGroups.find(additionGroup => additionGroup.id === groupId);
  const firstAdditionProductIndex = product?.additions.products.findIndex(additionProductId =>
    additionProductsFromGroup?.find(additionProduct => additionProduct?.id === additionProductId),
  );
  const additionGroupPosition =
    (additionGroup?.position || // if additionsGroups position is zero, check order from product additions
      firstAdditionProductIndex) ??
    -1;
  return additionGroupPosition;
}
